import React from 'react'
import { withAuthenticator, WithAuthenticatorProps } from '@aws-amplify/ui-react'
import { Link, Navigate } from 'react-router-dom'

import { useI18N } from '../../libraries/i18n/hook'
import { AppError } from '../../libraries/errors/AppError'
import ErrorMessage from '../components/errors/ErrorMessage'
import { CurrentUserContext, ACCESS_TYPES } from '../../libraries/auth'
import Button from '../components/form/Button'

const AccessExpired: React.FC<WithAuthenticatorProps> = ({ signOut }) => {
  const { t } = useI18N()
  if(!signOut) return null
  const { currentUser } = React.useContext(CurrentUserContext)
  if(!currentUser) {
    return <Navigate to='/onboarding' />
  }
  if(currentUser?.access?.active) {
    return <Navigate to='/' />
  }
  let message = t('auth.access.not.active')
  if(currentUser?.access?.accessType === ACCESS_TYPES.FREE) {
    message = t('auth.access.free.not.active')
  } else if(currentUser?.access?.accessType === ACCESS_TYPES.WORDPRESS) {
    message = t('auth.access.wordpress.not.active')
  }

  return (
    <div className='h-screen flex flex-col items-center justify-center'>
      <div className='mb-4'><ErrorMessage error={new AppError(message)} /></div>
      <Button onClick={signOut}><Link to='/'>{t('auth.login.with.another.account')}</Link></Button>
    </div>
  )
}

export default withAuthenticator(AccessExpired)
